<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="1001030401">
        <el-button type="primary" plain @click="() => toAlarmVehicleList()">报警车辆 {{alarmVehicleNum}}</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1001030402">
        <el-button type="primary" plain @click="() => toEdit()">新增围栏</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
<!--          <el-table-column type="selection" width="55" />-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section  slot-scope="scope">
                <!-- 中心地址 -->
                <section v-if="scope.column.property === 'centerAddress'">
                  <span v-if="scope.row.shapeType===1">{{scope.row[scope.column.property]}}</span>
                  <span v-else>--</span>
                </section>
                <!-- 中心地址 end -->
                <!-- 半径 -->
                <section v-else-if="scope.column.property === 'alarmRadius'">
                  <span v-if="scope.row.shapeType===1">{{scope.row[scope.column.property]}}</span>
                  <span v-else>--</span>
                </section>
                <!-- 半径 end -->
                <!-- 进围栏报警时间 -->
                <section v-else-if="scope.column.property === 'inFenceAlarmStartTime'">
                  <div>{{scope.row.inFenceAlarmStartTime }}</div>
                  <div style="text-align: center">-</div>
                  <div>{{scope.row.inFenceAlarmEndTime}}</div>
                </section>
                <!-- 进围栏报警时间 end -->
                <!-- 出围栏报警时间 -->
                <section v-else-if="scope.column.property === 'outFenceAlarmStartTime'">
                  <div >{{scope.row.outFenceAlarmStartTime }}</div>
                  <div style="text-align: center">-</div>
                  <div>{{scope.row.outFenceAlarmEndTime}}</div>
                </section>
                <!-- 出围栏报警时间 end -->
                <!-- 绑定车辆数 -->
                <section v-else-if="scope.column.property === 'bindCount'">
                  <span v-if="scope.row.fenceType===2">--</span>
                  <span v-else>{{scope.row[scope.column.property]}}</span>
                </section>
                <!-- 绑定车辆数 end -->
                <section v-else>{{scope.row[scope.column.property]}}</section>

              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="220"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :maxLength="3"
                :btnList="[
                  {
                    permpisions: '1001030403',
                    showCondition:  scope.row.fenceType===2,
                    name: '查看',
                    event: () => toView(scope.row.fenceId),
                  },
                  {
                    permpisions: '1001030403',
                    showCondition:  scope.row.fenceType!==2,
                    name: '编辑',
                    event: () => toEdit(scope.row.fenceId),
                  },
                  {
                    permpisions: '1001030404',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                  {
                    permpisions: '1001030405',
                    showCondition: scope.row.fenceType!==2,
                    name: '绑定/查看车辆',
                    event: () => toVehicleDetail(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {queryFenceList, delFence, queryFenceInOutVehicleAlarmCount} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      alarmVehicleNum: 0, // 报警车辆数
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'fenceName', label: '围栏名称'},
          {prop: 'fenceTypeName', label: '围栏类型'},
          {prop: 'effectiveStartTime', label: '开始时间'},
          {prop: 'effectiveEndTime', label: '结束时间'},
          {prop: 'shapeTypeName', label: '围栏形状'},
          {prop: 'centerAddress', label: '中心地址'},
          {prop: 'alarmRadius', label: '半径（米）'},
          {prop: 'speedValue', label: '围栏区域限速值（km/h）'},
          {prop: 'inFenceAlarmStartTime', label: '进围栏报警时间'},
          {prop: 'outFenceAlarmStartTime', label: '出围栏报警时间'},
          {prop: 'orgName', label: '适用部门'},
          {prop: 'bindCount', label: '绑定车辆数'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryFenceList,
    async handleSubSucc () {
      const res = await queryFenceInOutVehicleAlarmCount({
        fenceName: this.searchBoxData.fenceName,
        orgId: this.searchBoxData.orgId,
        effectiveStartTime: this.searchBoxData.effectiveStartTime,
        effectiveEndTime: this.searchBoxData.effectiveEndTime,
        fenceType: this.searchBoxData.fenceType,
      });
      this.alarmVehicleNum = res;
    },
    toAlarmVehicleList () {
      const fenceName = this.searchBoxData.fenceName;
      this.jump({
        label: '报警车辆',
        url: `/manage/operate/track/electronicFenceAlarmVehicle${fenceName ? '?fenceName=' + encodeURIComponent(fenceName) : ''}`,
        full: true,
      });
    },
    toVehicleDetail (item) {
      this.jump({
        label: '绑定/查看车辆',
        url: `/manage/operate/track/electronicFenceVehicleDetail?fenceId=${item.fenceId}&fenceName=${encodeURIComponent(item.fenceName)}`,
        full: true,
      });
    },
    toEdit (fenceId) {
      this.jump({
        label: fenceId ? '编辑围栏' : '新增围栏',
        url: `/manage/operate/track/electronicFence/edit${fenceId ? '?id=' + fenceId : ''}`,
        full: true,
      });
    },
    toView (fenceId) {
      this.jump({
        label: '查看围栏',
        url: `/manage/operate/track/electronicFence/edit${fenceId ? '?type=view&id=' + fenceId : ''}`,
        full: true,
      });
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.fenceName}】这条围栏信息吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await delFence({
          fenceId: item.fenceId,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
